import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, FullScreenLoading, TextInput } from "src/Components";
import { IBorderConfig } from "src/Interfaces/deltaHedgeBackTest";
import {
  getBorderConfig,
  setBorderConfig,
} from "src/Requests/deltaHedgeBackTest";
import { packetErrorHandler } from "src/Utils/requestUtils";

interface IProps {
  onClose: () => void;
  decileNumber: string;
  profileId: string;
  groupId: string;
}

const Config = ({ onClose, decileNumber, groupId, profileId }: IProps) => {
  const [config, setConfig] = useState({} as IBorderConfig);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getBorderConfig(decileNumber, profileId, groupId)
      .then((res) => {
        setConfig(res);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  }, []);

  const submitHandler = () => {
    setLoading(true);
    setBorderConfig(config, decileNumber, profileId, groupId).then((resp) => {
      if (!resp.data) toast.error(resp.msg);
      else {
        toast.success(resp.msg);
        onClose();
      }
    });
  };

  const changeHandler = (index: number, v: any) => {
    const arr = [...(config.teValues || [])];
    arr[index] = v;
    setConfig({ teValues: arr });
  };

  return (
    <div className="flex flex-col justify-start items-end gap-5">
      <div className="grid grid-cols-3 gap-3">
        {loading ? <FullScreenLoading /> : <></>}
        {config.teValues?.map((te, i) => (
          <TextInput
            label={`%TE-${(i + 1).toString().padStart(2, "0")}`}
            name=""
            onChange={(_, v) => changeHandler(i, v)}
            value={te?.toString()}
            extraLabel
          />
        ))}
      </div>
      <Button onClick={submitHandler} text="ثبت" variant="contained" />
    </div>
  );
};

export default Config;
